<template>
  <div
    class="progress-bar__mobile"
    :class="route.name + greyLabelClass"
    v-if="route.name !== 'summary'"
  >
    <div class="progress-bar__mobile__el" :class="progressState.verification">
      <VerificationIcon />
      <p :class="greyLabelClass">{{ $t('ProgressBar.label.verify') }}</p>
    </div>
    <div
      class="progress-bar__mobile__divider"
      :class="progressState.verification"
    ></div>
    <div class="progress-bar__mobile__el" :class="progressState.identity">
      <IdentityIcon />
      <p :class="greyLabelClass">{{ $t('ProgressBar.label.identify') }}</p>
    </div>
    <div
      class="progress-bar__mobile__divider"
      :class="progressState.identity"
    ></div>
    <div class="progress-bar__mobile__el" :class="progressState.payment">
      <PaymentIcon />
      <p :class="greyLabelClass">
        {{ orderStore.isBuyMode ? $t('ProgressBar.label.payment') : $t('ProgressBar.label.deposit') }}
      </p>
    </div>
  </div>
</template>
<script setup>
import { computed } from "vue";
import { useRoute } from "vue-router";
import { useGlobalStore } from "@/stores/globalStore";
import { useOrderFormStore } from "@/stores/forms/orderFormStore";
import VerificationIcon from "@/components/icons/Verification.vue";
import PaymentIcon from "@/components/icons/Payment.vue";
import IdentityIcon from "@/components/icons/Identity.vue";

const store = useGlobalStore();
const orderStore = useOrderFormStore();
const route = useRoute();
const props = defineProps({
  progressState: {
    type: Object,
  },
});

const greyLabelClass = computed(() =>
  store.getIsGreyLabel ? " grey-label" : ""
);
</script>
<style lang="scss">
.progress-bar__mobile {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 2rem;
  transition: opacity 250ms;
  opacity: 1;
  padding-top: var(--padding-1);

  &.order {
    opacity: 0.2;
  }

  @include breakpoint($min-m) {
    display: none;
  }

  &__el {
    position: relative;
    svg {
      width: 3.2rem;
    }

    p {
      position: absolute;
      left: 50%;
      transform: translateX(-50%) translateY(1rem);

      @include breakpoint($min-m) {
        font-size: $font-head;
      }

      @include breakpoint($min-m) {
        display: none;
      }
    }
  }

  &__divider {
    flex: 1;
    background: var(--input-background);
    height: 1px;
    position: relative;

    &:after {
      content: "";
      width: 100%;
      height: 100%;
      background: var(--secondary);
      position: absolute;
      transform-origin: 0 0;
      transform: scaleX(0);
      transition: transform 750ms ease-in-out;
    }

    &.INCOMPLETE {
      &:after {
        transform: scaleX(0);
      }
    }

    &.PENDING {
      &:after {
        transform: scaleX(0.5);
      }
    }

    &.COMPLETE {
      &:after {
        transform: scaleX(1);
      }
    }
  }
}

.progress-bar__mobile.grey-label {
  padding-top: 3em;
  display: flex;
  order: 1;
  width: 100%;
}

p.grey-label {
  display: block;
}
</style>
